import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { gradientBackgroundAnimation } from 'app/styles/mixins';
import { isMobile } from 'app/helpers/utils';

const El = styled.button.attrs({
  tabIndex: 0,
})`
  letter-spacing: ${({ letterSpacing }) => letterSpacing}px;
  font-size: ${({ size }) => size}px;
  font-weight: 700;
  text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
  text-align: center;
  padding: ${({ padding }) => padding || '11px 0'};
  color: ${({ inverse }) => (inverse ? '#F29E76' : 'white')};
  border-radius: 100px;
  appearance: none;
  border: ${({ inverse }) => (inverse ? '2px solid #F49F61' : 0)};
  width: ${({ width }) => width || '100%'};
  box-shadow: ${({ inverse }) => (inverse ? 'none' : '0 4px 3px 0 #e2e2e280')};

  &:not(:disabled):hover {
    box-shadow: 0 5px 6px 0 #e2e2e280;
    color: white;
    border: ${({ inverse }) => (inverse ? '2px solid #ef8565' : 0)};
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    color: #c2c3c5;
    box-shadow: none;
    background: ${({ inverse }) => (inverse ? 'transparent' : '#F8F8F8')};
    border: ${({ inverse }) => (inverse ? '2px solid #f8f8f8' : 0)};
  }

  ${({ green }) => {
    const orangeStart = 'linear-gradient(to right, #f49f61, #f19e85)';
    const orangeHover = 'linear-gradient(to right, #f38c41, #ef8667)';
    const greenHover = 'linear-gradient(to right, #4CAF50, #43A047)';
    const greenStart = 'linear-gradient(to right, #73B567, #73B567)';
    const start = green && green ? greenStart : orangeStart;
    const hover = green && green ? greenHover : orangeHover;
    return gradientBackgroundAnimation(start, hover, '0.25s');
  }};

  ${({ inverse }) => inverse && 'background:transparent'};
`;

const Loader = styled.i.attrs({
  className: 'fas fa-spinner fa-spin',
})``;

const Button = ({ children, loading, ...rest }) => {
  const displayAsLoading = loading === 'global';
  return (
    <El disabled={displayAsLoading} {...rest}>
      {displayAsLoading ? <Loader /> : children}
    </El>
  );
};

Button.defaultProps = {
  inverse: false,
  disabled: false,
  type: 'button',
  letterSpacing: isMobile ? 0.88 : 0.75,
  size: 14,
  green: false,
};

Button.propTypes = {
  size: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  inverse: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  letterSpacing: PropTypes.number.isRequired,
  green: PropTypes.bool.isRequired,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

const mapStateToProps = ({ loading }) => ({ loading });

export default connect(mapStateToProps, null)(Button);
